import { render } from "./CommunitySimp.vue?vue&type=template&id=a8b4bfb0"
import script from "./CommunitySimp.vue?vue&type=script&lang=js"
export * from "./CommunitySimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__